/* eslint-disable react/require-default-props */
import React, { ReactNode } from "react";

import Container from "../atoms/Container";
import ThemeToggle, { ThemeProvider, useTheme } from "../molecules/ThemeToggle";

interface AppLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}

/**
 * The home page's look for a signed-in page that still sits under the legacy
 * Bootstrap navbar: same dotted background, typography and theme cookie as
 * MarketingLayout, without its marketing header and footer (the navbar above
 * is the app's navigation). font-sans is explicit because Bootstrap sets the
 * body font to Roboto.
 */
function AppShell({ title, description, children }: AppLayoutProps) {
  const { isDark } = useTheme();

  return (
    // m-0 p-0 bg-transparent: the legacy style.css styles a bare .dark class
    // as a padded gray box, and this wrapper carries that class name.
    <div className={`m-0 bg-transparent p-0 ${isDark ? "dark" : ""}`}>
      <div className="bg-dotted min-h-screen pb-16 pt-10 font-sans text-left text-gray-900 dark:text-gray-100 md:pt-12">
        <Container>
          <div className="mb-8 flex items-start justify-between gap-4">
            <div>
              <h1 className="text-left text-3xl font-medium tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl">
                {title}
              </h1>
              {description ? (
                <p className="mt-2 text-base text-gray-600 dark:text-gray-400">
                  {description}
                </p>
              ) : null}
            </div>
            <ThemeToggle />
          </div>
          {children}
        </Container>
      </div>
    </div>
  );
}

export default function AppLayout({
  title,
  description,
  children,
}: AppLayoutProps) {
  return (
    <ThemeProvider>
      <AppShell title={title} description={description}>
        {children}
      </AppShell>
    </ThemeProvider>
  );
}
